import { render, staticRenderFns } from "./Weiterbildung.vue?vue&type=template&id=85466dfe&scoped=true&"
import script from "./Weiterbildung.vue?vue&type=script&lang=js&"
export * from "./Weiterbildung.vue?vue&type=script&lang=js&"
import style0 from "./Weiterbildung.vue?vue&type=style&index=0&id=85466dfe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85466dfe",
  null
  
)

export default component.exports